import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col min-h-screen" }
const _hoisted_2 = { class: "py-8 items-center container" }
const _hoisted_3 = { class: "ml-4 bg-white" }
const _hoisted_4 = { class: "sm:flex flex-row items-center justify-between w-full" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-2xl text-gray-400 font-thin" }, "Create new candidate")
], -1)
const _hoisted_6 = { class: "flex flex-row justify-between items-center space-x-3" }
const _hoisted_7 = { class: "flex-grow bg-background" }
const _hoisted_8 = { class: "container mt-8" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_Button = _resolveComponent("Button")!
  const _component_CandidateForm = _resolveComponent("CandidateForm")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Header),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_Button, {
              variant: "outlined",
              label: "Cancel",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/candidates')))
            }),
            _createVNode(_component_Button, {
              variant: "contained",
              label: 
                _ctx.isLoadingButton ? 'Creating candidate...' : 'Create candidate'
              ,
              onClick: _ctx.onSaveCandidate,
              disabled: !_ctx.isValidForm || _ctx.isLoadingButton
            }, null, 8, ["label", "onClick", "disabled"])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_CandidateForm, {
          typeForm: _ctx.typeForm,
          saveCandidate: _ctx.saveCandidate,
          onOnValidForm: _ctx.onValidForm,
          onOnError: _ctx.onError,
          onIsLoadingAction: _ctx.isLoadingAction
        }, null, 8, ["typeForm", "saveCandidate", "onOnValidForm", "onOnError", "onIsLoadingAction"])
      ])
    ])
  ]))
}